
/** 上传地址 */
export const upLoadImg = 'https://ai.kbsdkj.cn/api/comm/file/upload2';